import React, { useState } from "react";
import { VStack, Box, Text, Alert, AlertIcon, Stack } from "@chakra-ui/react";
import { useCustomNotification } from "components/Toasts/OpenNotification";
import ReusableModal from "components/Modals/ReusableModal";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";
import { formatBWP } from "../utils/formatBWP";

const RefundModal = ({ isOpen, onClose, paygateTransactionId, refundAmount, onRefund, status }) => {
  const [refundReason, setRefundReason] = useState("");
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const showToast = useCustomNotification();

  const handleClick = async () => {
    setIsLoading(true);
    try {
      const result = await onRefund({ paygateTransactionId, refundReason, refundAmount });

      if (result.success) {
        showToast({
          type: "success",
          message: "Refund Successful",
          description: "The refund was processed successfully.",
        });
        setIsLoading(false);
        setRefundReason("");
        onClose();
      } else {
        showToast({
          type: "error",
          message: "Refund Failed",
          description: result.error || "Refund failed, please try again.",
        });
        setIsLoading(false);
      }
    } catch (err) {
      showToast({
        type: "error",
        message: "Refund Failed",
        description: "Refund failed, please try again.",
      });
      setIsLoading(false);
    }
  };

  const disableButton =
    !paygateTransactionId ||
    isLoading ||
    ["Refunded", "Failed", "Pending"].includes(status);

  return (
    <ReusableModal
      isOpen={isOpen}
      onClose={onClose}
      title="Process Refund"
      bodyMessage={
        <VStack spacing={4} align="stretch">
          <Box>
            <Text mb={2} fontWeight="semibold" fontSize="sm" color="#8D93A1">
              Refund Amount: {formatBWP(refundAmount)}
            </Text>
          </Box>

          <ReusableInput
            label="Refund Reason (optional)"
            type="textarea"
            placeholder="Enter reason for refund"
            value={refundReason}
            onChange={(e) => setRefundReason(e.target.value)}
          />

          {error && (
            <Alert status="error">
              <AlertIcon />
              {error}
            </Alert>
          )}

          <Stack direction="row" spacing={4} justifyContent="flex-end" pt={4}>
            <GradientButton
              onClick={onClose}
              fontSize="15px"
              width="100px"
              height="40px"
              isDisabled={isLoading}
            >
              Cancel
            </GradientButton>
            <GradientButton
              onClick={handleClick}
              fontSize="15px"
              width="120px"
              height="40px"
              loading={isLoading}
              isDisabled={disableButton}
            >
              Process Refund
            </GradientButton>
          </Stack>
        </VStack>
      }
      showConfirmButton={false}
      showCancelButton={false}
    />
  );
};

export default RefundModal;
